<template>
  <v-card class="p-4">
    <template v-slot:title> Account Summary </template>
    <template v-slot:append>
      <v-icon @click="$emit('closeDialog')">mdi-close</v-icon>
    </template>
    <v-card-text class="flex">
      <div class="w-7/12 pr-4">
        <div class="text-sm text-left text-gray-900">
          Provide your clients with a summary of new changes to their account.
        </div>
        <div class="py-2 text-sm text-left text-gray-900">
          These are the definitions of each line item automatically generated in
          the account and retainer summaries your clients will receive in their
          invoice emails.
        </div>
        <div class="py-2">
          <div class="p-2 text-white mb-1 bg-legend-header">
            Account Summary
          </div>
          <div class="flex p-2 mb-1 bg-legend-row-light">
            <span class="w-4/12">Balance Forward</span>
            <span class="w-8/12"
              >Existing account balance for client or matter</span
            >
          </div>
          <div class="flex p-2 mb-1 bg-legend-row-faint">
            <span class="w-4/12">New Charges</span>
            <span class="w-8/12">Invoice amount</span>
          </div>
          <div class="flex p-2 mb-1 bg-legend-row-light">
            <span class="w-4/12">Payments Received*</span>
            <span class="w-8/12"
              >Any other actual payments recorded on the invoice</span
            >
          </div>
          <div class="flex p-2 mb-1 bg-legend-row-faint">
            <span class="w-4/12">Paid from Retainer*</span>
            <span class="w-8/12"
              >Any actual payments recorded from the client's retainer</span
            >
          </div>
          <div class="flex mb-1 p-2 bg-legend-row-light">
            <span class="w-4/12">To Pay</span>
            <span class="w-8/12">The calculated amount owed to the firm</span>
          </div>
          <!-- break -->
          <div
            class="p-2 flex text-white mb-1 bg-legend-header"
          >
            <span class="w-4/12">Retainer Summary</span>
            <span class="w-8/12"
              >Only populates if the client or matter has a trust account</span
            >
          </div>
          <div class="flex p-2 mb-1 bg-legend-row-faint">
            <span class="w-4/12">Starting Retainer Balance</span>
            <span class="w-8/12"
              >Retainer balance before recording any payments</span
            >
          </div>
          <div class="flex p-2 mb-1 bg-legend-row-light">
            <span class="w-4/12">Ending Retainer Balance</span>
            <span class="w-8/12"
              >Retainer balance after sending the invoice</span
            >
          </div>
          <div class="flex p-2 mb-1 bg-legend-row-faint">
            <span class="w-4/12">Retainer Minimum Balance*</span>
            <span class="w-8/12">The evergreen retainer amount</span>
          </div>
        </div>
        <div class="py-4">
          *These line items will only appear in the summary if there is a
          non-zero amount to show.
        </div>
      </div>
      <div class="pl-4 w-5/12 pt-6">
        <div>
          <div class="py-4"><b>Example preview:</b></div>
          <div class="border-2 border-green-regular p-2">
            <div class="p-2 text-base font-bold">
              <span>Account Summary</span>
            </div>
            <div class="flex justify-between px-2">
              <span>Balance Forward</span>
              <span>$100.00</span>
            </div>
            <div class="flex justify-between px-2">
              <span>New Charges</span>
              <span>$100.00</span>
            </div>
            <div class="flex justify-between px-2">
              <span>Payments Received</span>
              <span class="text-red-500">-$60.00</span>
            </div>
            <div class="flex justify-between px-2">
              <span>Paid from Retainer</span>
              <span class="text-red-500">-$10.00</span>
            </div>
            <div
              class="flex justify-between px-2 text-green-regular border-t-2 border-gray-700"
            >
              <span>To Pay</span>
              <span>$130.00</span>
            </div>
            <!-- break -->
            <div class="p-2 text-base font-bold">
              <span>Retainer Summary</span>
            </div>
            <div class="flex justify-between px-2 italic">
              <span>Starting Retainer Balance</span>
              <span>$10.00</span>
            </div>
            <div class="flex justify-between px-2 italic">
              <span>Ending Retainer Balance</span>
              <span>$0.00</span>
            </div>
            <div class="flex justify-between px-2 italic pb-2">
              <span>Retainer Minimum Balance</span>
              <span>$123.00</span>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="flex justify-end mr-4 mb-4">
      <LlSecondaryButton
        variant="outlined"
        class="px-4"
        @click.prevent="$emit('closeDialog')"
      >
        Close
      </LlSecondaryButton>
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';

defineEmits(['closeDialog']);
</script>